import React, { useEffect, useState } from "react";
import { appPageContents } from "../api/api";
import "../TermsandCondition/TermsandCondition.css";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from "react-icons/fa";

const Gdpr = () => {
  const [termsConditions, setTermsConditions] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      setLoading(true);
      try {
        const values = { page_type: "gdpr" };
        const response = await appPageContents(values);
        console.log("PrivacyPolicy API Response:", response);

        if (response?.content?.desc) {
          const cleanText = response.content.desc
            .replace(/<hr\s*\/?>/g, "")
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">");
          setTermsConditions(cleanText);
        }
      } catch (error) {
        console.error("Error fetching PrivacyPolicy:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTermsAndConditions();
  }, []);

  return (
    <div className="registration-privacy-container">
      <div
        className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
        <h4>Child Sexual Abuse & Exploitation (CSAE)</h4>
        <p>
          Home{" "}
          <span>
            <FaChevronRight />
          </span>{" "}
          Child Sexual Abuse & Exploitation (CSAE)
        </p>
      </div>
      <div className="containerall">
        <div className="registration-privacy-card">
          <div className="registration-privacy-header">
            Child Sexual Abuse & Exploitation (CSAE)
          </div>
          <div className="registration-privacy-body">
            {loading ? (
              <div className="registration-privacy-loader-container">
                <div className="registration-custom-spinner"></div>
              </div>
            ) : (
              <div className="registration-privacy-content">
                <p className="registration-privacy-text">{termsConditions}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gdpr;
